import { apiClient } from "./client";

/**
 * Parse an already-uploaded resume document via its s3Key.
 * Returns: { extracted, currentProfile, isOcr, fileName }
 */
export async function parseResume({ s3Key, fileName, mimeType }) {
  const res = await apiClient.post("/professional/resume/parse", {
    s3Key,
    fileName,
    mimeType,
  });
  return res.data?.data || res.data;
}

/**
 * Directly upload and parse a resume file using multipart/form-data.
 * Fallback when direct S3 presigned upload is not preferred.
 */
export async function parseResumeDirect(file) {
  const formData = new FormData();
  formData.append("file", file);

  const res = await apiClient.post("/professional/resume/parse", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data?.data || res.data;
}

/**
 * Apply reviewed resume information to the current professional's profile
 * and create unverified (status NONE) credentials.
 * Never executes without explicit user confirmation.
 */
export async function applyResume(payload) {
  const res = await apiClient.post("/professional/resume/apply", payload);
  return res.data?.data || res.data;
}
